/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$('body').addClass('dom-loaded');

$('[data-toggle-dyknav]').click(function(e) {
    e.preventDefault();
    $(this).parents('ul').toggleClass('active');
});

if ($('.dyk-tabs').length) {
    var tabsOffset = $('.dyk-tabs').offset().top + $('.dyk-tabs').height();

    setInterval(function() {
        if ($(window).scrollTop() >= tabsOffset) {
            $('.dyk-tabs-fixed').addClass('fixed');
        } else {
            $('.dyk-tabs-fixed').removeClass('fixed');
        }
    }, 100);
}

if ($('.dyk-full-video').length) {
    $('.dyk-full-video video').get(0).addEventListener('ended',loopVideo,false);

    function loopVideo(e) {
        //console.log('ended');
        setTimeout(function(){
            $('.dyk-full-video video').get(0).play();
        }, 10000);
    }
}

if ($('.dyk-slides').length) {
    var dykSlideInterval = setInterval(function() {
        dykSlideNext();
        dykSlideHeight();
    }, 7000);

    $('.dyk-slide-controls .prev').click(function(e) {
        e.preventDefault();
        if ($(this).parents('.dyk-slide').hasClass('active')) {
            dykSlidePrev();
            dykSlideHeight();
            clearInterval(dykSlideInterval);
        }
    });

    $('.dyk-slide-controls .next').click(function(e) {
        e.preventDefault();
        if ($(this).parents('.dyk-slide').hasClass('active')) {
            dykSlideNext();
            dykSlideHeight();
            clearInterval(dykSlideInterval);
        }
    });
}

function dykSlidePrev() {
    var current = $('.dyk-slide.active');
    var next = current.prev();

    if (!next.length) {
        next = $('.dyk-slide:last-child');
    }

    current.removeClass('active');
    next.addClass('active');
}

function dykSlideNext() {
    var current = $('.dyk-slide.active');
    var next = current.next();

    if (!next.length) {
        next = $('.dyk-slide:first-child');
    }

    current.removeClass('active');
    next.addClass('active');
}

function dykSlideHeight() {
    var height = 0;

    $('.dyk-slide').each(function() {
        if ($(this).height() >= height) {
            height = $(this).height();
        }
    });

    $('.dyk-slides').css('min-height', height + 'px');
}
